/** Google OAuth client ID for Drive connect on tenant tasks (optional in local dev). */
export const googleClientId = String((import.meta as { env?: { VITE_GOOGLE_CLIENT_ID?: string } }).env?.VITE_GOOGLE_CLIENT_ID ?? '').trim()

export const isGoogleOAuthConfigured = googleClientId.length > 0
